import { render, staticRenderFns } from "./diagnosis-consultation-modal.vue?vue&type=template&id=77dba6c4&scoped=true&"
import script from "./diagnosis-consultation-modal.ts?vue&type=script&lang=ts&"
export * from "./diagnosis-consultation-modal.ts?vue&type=script&lang=ts&"
import style0 from "./diagnosis-consultation-modal.scss?vue&type=style&index=0&id=77dba6c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dba6c4",
  null
  
)

export default component.exports